import React, { useState, useEffect } from 'react';
import { X, ExternalLink } from 'lucide-react';

const BG_COLORS = {
  navy: 'bg-[#101C47] text-white',
  red: 'bg-[#d32f2f] text-white',
  green: 'bg-emerald-600 text-white',
  amber: 'bg-amber-500 text-white',
};

const NotificationBar = () => {
  const [notifications, setNotifications] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('dismissedNotifs') || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    fetch(`${API}/api/notifications/active`)
      .then(r => r.json())
      .then(data => setNotifications(data.notifications || []))
      .catch(() => {});
  }, []);

  const dismiss = (id) => {
    const updated = [...dismissed, id];
    setDismissed(updated);
    sessionStorage.setItem('dismissedNotifs', JSON.stringify(updated));
  };

  const visible = notifications.filter(n => !dismissed.includes(n.id));
  if (visible.length === 0) return null;

  return (
    <div data-testid="notification-bar-container">
      {visible.map(n => (
        <div
          key={n.id}
          className={`${BG_COLORS[n.bg_color] || BG_COLORS.navy} relative`}
          data-testid={`notification-bar-${n.id}`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-10 py-2.5 flex items-center justify-center gap-3 text-sm">
            <span className="font-medium text-center">{n.text}</span>
            {n.link_text && n.link_url && (
              <a
                href={n.link_url}
                className="underline underline-offset-2 font-semibold flex items-center gap-1 flex-shrink-0 hover:opacity-80 transition-opacity"
                data-testid={`notification-link-${n.id}`}
              >
                {n.link_text}
                <ExternalLink size={12} />
              </a>
            )}
            <button
              onClick={() => dismiss(n.id)}
              className="absolute right-3 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100 transition-opacity"
              aria-label="Dismiss notification"
              data-testid={`notification-dismiss-${n.id}`}
            >
              <X size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationBar;
